const Carrers = [
  {
    id: 1,
    title: "PHP Developer (Laravel/CI)",
    location: "Pune, India",
    type: "Full-time",
    slug: "php-developer-laravel-ci",
    experience: "3+ Years",
    categories: ["development", "Engineering", "Backend"],
    openings: 2,
    deadline: "September 30, 2025",
    department: "Technology & Engineering",
    salary: "₹8,00,000 – ₹12,00,000 per annum",
    description:
      "We are seeking a skilled and passionate PHP Developer to join our dynamic engineering team. In this role, you will be responsible for developing and maintaining high-quality web applications using modern PHP frameworks like Laravel and CodeIgniter. You will have the opportunity to work on exciting projects, contribute to our growing codebase, and collaborate with a talented team to deliver outstanding digital solutions.",
    responsibilities: [
      "Design, develop, and maintain robust, scalable, and secure web applications using PHP, Laravel, and CodeIgniter.",
      "Write clean, efficient, and well-documented code following industry best practices and coding standards.",
      "Collaborate with front-end developers, UI/UX designers, and product managers to integrate user-facing elements.",
      "Develop and manage relational databases, primarily MySQL, and create optimized database queries.",
      "Build and consume RESTful APIs for seamless communication between services.",
      "Troubleshoot, debug, and upgrade existing software to enhance functionality and performance.",
      "Participate actively in the entire software development lifecycle, from planning and design to deployment and support.",
    ],
    qualifications: [
      "Bachelor's degree in Computer Science, Engineering, or a related field, or equivalent practical experience.",
      "3+ years of professional experience in PHP web development.",
      "Strong proficiency with modern PHP frameworks, specifically Laravel and/or CodeIgniter.",
      "Solid understanding of Object-Oriented Programming (OOP) concepts and MVC architecture.",
      "Experience with relational databases (e.g., MySQL, PostgreSQL) and writing efficient SQL.",
      "Proficiency with version control systems, particularly Git.",
      "Familiarity with front-end technologies such as HTML5, CSS3, and JavaScript.",
    ],
    niceToHave: [
      "Experience with front-end JavaScript frameworks like Vue.js or React.",
      "Knowledge of containerization tools like Docker.",
      "Familiarity with cloud platforms (e.g., AWS, Azure, Google Cloud).",
      "Experience with setting up and maintaining CI/CD pipelines.",
      "Understanding of unit testing and TDD principles.",
    ],
    benefits: [
      "Competitive salary and performance-based bonuses.",
      "Comprehensive health insurance for you and your family.",
      "Flexible work hours and hybrid remote work options.",
      "A generous budget for professional development, courses, and certifications.",
      "Paid time off, including vacation, sick leave, and public holidays.",
      "A vibrant, collaborative, and growth-oriented work environment.",
    ],
  },
  {
    id: 2,
    title: "React JS Developer",
    location: "Nashik, India",
    type: "Full-time",
    slug: "react-js-developer",
    experience: "2+ Years",
    categories: ["development"],
    openings: 2,
    deadline: "September 15, 2025",
    department: "Development",
    salary: "₹6L - ₹9L / year",
    description: `We’re seeking a talented React JS Developer with a strong foundation in building responsive, high-performance web applications. You'll be working closely with cross-functional teams to design, develop, and deploy modern, scalable user interfaces.`,
    responsibilities: [
      "Develop modern web applications using React.js.",
      "Collaborate with UI/UX designers and backend developers.",
      "Write clean, efficient, and reusable code.",
      "Optimize components for performance across devices.",
      "Integrate APIs and manage application state effectively.",
    ],
    qualifications: [
      "Minimum 2 years of experience with React.js.",
      "Strong understanding of Redux, hooks, and component lifecycle.",
      "Proficiency with HTML, CSS, JavaScript (ES6+).",
      "Experience working with RESTful APIs and Git.",
      "Familiarity with modern frontend build pipelines and tools.",
    ],
    niceToHave: [
      "Knowledge of TypeScript.",
      "Experience with testing frameworks like Jest or React Testing Library.",
      "Understanding of CI/CD and DevOps basics.",
    ],
    benefits: [
      "Competitive salary based on experience.",
      "Flexible working hours.",
      "Opportunities for growth and learning.",
      "Supportive and collaborative work environment.",
      "Health and wellness programs.",
    ],
  },
  {
    id: 3,
    title: "React Native Developer",
    location: "Nashik, India",
    type: "Full-time",
    slug: "react-native-developer",
    experience: "2+ Years",
    categories: ["development", "Mobile", "Engineering"],
    openings: 3,
    deadline: "October 31, 2025",
    department: "Mobile App Development",
    salary: "₹7,00,000 – ₹11,00,000 per annum",
    description:
      "We are looking for a talented React Native Developer to join our innovative mobile team. You will be responsible for building high-quality, cross-platform mobile applications for both iOS and Android. If you are passionate about mobile technology and thrive in a collaborative environment, this is the perfect opportunity to make a significant impact on our products. 📱",
    responsibilities: [
      "Develop, test, and deploy robust, scalable, and user-friendly mobile applications using React Native.",
      "Collaborate with product managers, UI/UX designers, and backend developers to create a seamless user experience.",
      "Write clean, maintainable, and well-documented code.",
      "Integrate third-party APIs and services.",
      "Optimize application performance for speed and responsiveness.",
      "Troubleshoot and debug issues to ensure application stability.",
      "Stay current with emerging mobile technologies and best practices.",
    ],
    qualifications: [
      "Proven experience as a React Native Developer with a strong portfolio of released applications.",
      "Deep understanding of the React Native framework and its core principles.",
      "Proficiency in **JavaScript** and **TypeScript**.",
      "Experience with state management libraries like **Redux** or **MobX**.",
      "Familiarity with RESTful APIs and asynchronous request handling.",
      "Experience with version control systems, especially **Git**.",
      "Strong problem-solving skills and attention to detail.",
    ],
    niceToHave: [
      "Experience with native mobile development (Java/Kotlin for Android or Swift/Objective-C for iOS).",
      "Familiarity with CI/CD pipelines for mobile applications.",
      "Knowledge of automated testing frameworks like Detox or Appium.",
      "Experience with publishing applications to the Apple App Store and Google Play Store.",
      "Understanding of native build tools like Xcode and Android Studio.",
    ],
    benefits: [
      "Competitive salary and annual performance bonus.",
      "Comprehensive health insurance plan.",
      "Flexible working hours and a hybrid work model.",
      "Opportunities for professional growth and skill development.",
      "A modern and collaborative office space.",
      "Generous paid leave and company holidays.",
    ],
  },
  {
    id: 4,
    title: "Graphic Designer",
    location: "Nashik, India",
    type: "Full-time",
    slug: "graphic-designer",
    experience: "2+ Years",
    categories: ["design", "marketing", "Creative"],
    openings: 1,
    deadline: "October 15, 2025",
    department: "Marketing & Creative Services",
    salary: "₹4,00,000 – ₹6,50,000 per annum",
    description:
      "We're looking for a creative and talented Graphic Designer to join our marketing team! 🎨 You'll be the driving force behind our brand's visual identity, creating compelling graphics for digital and print campaigns. If you have a passion for visual storytelling and a keen eye for detail, we'd love to see your portfolio.",
    responsibilities: [
      "Conceptualize and create visually appealing graphics for social media, websites, email campaigns, and digital ads.",
      "Design marketing collateral including brochures, flyers, presentations, and event materials.",
      "Ensure all visual content is consistent with our brand guidelines and identity.",
      "Collaborate with marketing, content, and product teams to translate requirements into effective design.",
      "Manage multiple design projects from concept to completion within deadlines.",
      "Stay up-to-date with industry trends and tools to keep our designs fresh and modern.",
    ],
    qualifications: [
      "A strong portfolio showcasing creative and high-quality design work.",
      "2+ years of professional graphic design experience.",
      "Expert proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign).",
      "Solid understanding of color theory, typography, and layout principles.",
      "Excellent communication and collaboration skills.",
      "Ability to manage time effectively and handle multiple projects simultaneously.",
      "Bachelor's degree in Graphic Design, Fine Arts, or a related field.",
    ],
    niceToHave: [
      "Experience with video editing software like Adobe Premiere Pro or After Effects.",
      "Basic knowledge of UI/UX design principles.",
      "Familiarity with web design tools like Figma or Sketch.",
      "Illustration skills, either digital or traditional.",
      "Experience working in a fast-paced marketing environment.",
    ],
    benefits: [
      "Competitive salary and performance incentives.",
      "Comprehensive health insurance plan.",
      "Flexible working hours and a creative work atmosphere.",
      "Opportunities for professional growth and skill development.",
      "Generous paid leave and company holidays.",
      "Team outings and a collaborative, supportive culture. 🎉",
    ],
  },
  {
    id: 5,
    title: "Video Graphics Designer",
    location: "Nashik, India",
    type: "Full-time",
    slug: "video-graphics-designer",
    experience: "2+ Years",
    categories: ["design", "Video Production", "marketing"],
    openings: 1,
    deadline: "October 15, 2025",
    department: "Marketing & Creative Services",
    salary: "₹4,00,000 – ₹7,00,000 per annum",
    description:
      "We're looking for a creative and talented Video Graphics Designer to join our marketing team! 🎨 You'll be the driving force behind our visual storytelling, creating compelling motion graphics and video content that captivates our audience across various digital platforms. If you have a passion for design and a knack for bringing ideas to life through video, we'd love to meet you.",
    responsibilities: [
      "Conceptualize and create engaging motion graphics, animations, and visual effects for marketing videos, social media, and internal projects.",
      "Edit raw video footage into polished, professional final products that align with our brand identity.",
      "Collaborate with the marketing and content teams to develop video concepts and storyboards.",
      "Manage and organize video project files, assets, and archives.",
      "Ensure all video content meets high standards of quality, brand consistency, and technical specifications.",
      "Stay current with the latest video production trends, techniques, and software.",
    ],
    qualifications: [
      "A strong portfolio showcasing your video editing and motion graphics skills.",
      "2+ years of professional experience in video editing and graphic design.",
      "Expert proficiency in Adobe Creative Suite, especially **After Effects**, **Premiere Pro**, **Photoshop**, and **Illustrator**.",
      "Solid understanding of design principles, including typography, color theory, and composition.",
      "Ability to work effectively on multiple projects and meet deadlines in a fast-paced environment.",
      "Excellent communication skills and the ability to interpret creative briefs.",
      "A keen eye for detail and a passion for creating high-quality visual content.",
    ],
    niceToHave: [
      "Experience with 3D modeling and animation software (e.g., Blender, Cinema 4D).",
      "Proficiency in audio editing and sound design (e.g., Adobe Audition).",
      "Familiarity with camera operation and basic lighting principles.",
      "Experience creating content specifically for social media platforms like Instagram Reels, YouTube Shorts, and TikTok.",
    ],
    benefits: [
      "Competitive salary and a creative work environment.",
      "Comprehensive health insurance plan.",
      "Flexible work schedule and paid time off.",
      "Opportunities for professional growth and skill development.",
      "Access to the latest design software and hardware.",
      "Team outings and a collaborative, supportive culture.",
    ],
  },
  {
    id: 6,
    title: "Digital Marketing Executive",
    location: "Nashik, India",
    type: "Full-time",
    slug: "digital-marketing-executive",
    experience: "2+ Years",
    categories: ["marketing", "SEO", "Social Media"],
    openings: 1,
    deadline: "October 15, 2025",
    department: "Marketing & Growth",
    salary: "₹4,00,000 – ₹6,00,000 per annum",
    description:
      "We are looking for a dynamic and results-driven Digital Marketing Executive to develop, implement, track, and optimize our digital marketing campaigns across all channels. You will play a crucial role in enhancing our brand awareness, driving web traffic, and acquiring leads/customers. If you are passionate about digital technologies and marketing trends, we'd love to meet you! 🚀",
    responsibilities: [
      "Plan and execute all digital marketing campaigns, including SEO/SEM, email, social media, and display advertising.",
      "Manage and maintain the organization's social media presence across all relevant digital channels.",
      "Measure and report on the performance of all digital marketing campaigns, assessing against goals (ROI and KPIs).",
      "Identify trends and insights to optimize ad spend and campaign performance.",
      "Collaborate with internal teams to create optimized landing pages and improve the user experience.",
      "Brainstorm new and creative growth strategies to increase our digital footprint.",
      "Conduct keyword research and use SEO best practices to increase site traffic.",
    ],
    qualifications: [
      "Bachelor's degree in Marketing, Communications, or a related field.",
      "2+ years of proven experience in a digital marketing or advertising position.",
      "Demonstrable experience managing SEO/SEM, email, social media, and/or display advertising campaigns.",
      "Solid knowledge of website analytics tools (e.g., Google Analytics, SEMrush, Ahrefs).",
      "Experience in setting up and optimizing Google Ads campaigns.",
      "Strong analytical skills and a data-driven approach to problem-solving.",
      "Excellent written and verbal communication skills.",
    ],
    niceToHave: [
      "Experience with content creation, including copywriting and basic graphic design.",
      "Familiarity with marketing automation tools like HubSpot or Mailchimp.",
      "Basic knowledge of HTML and CSS.",
      "Certifications in Google Ads or Google Analytics.",
      "Experience with A/B and multivariate experiments.",
    ],
    benefits: [
      "Competitive salary and performance incentives.",
      "Comprehensive health insurance plan.",
      "A supportive environment with opportunities for professional growth and training.",
      "A creative, collaborative, and fun work culture.",
      "Generous paid leave and flexible work arrangements.",
      "Regular team-building activities and company outings.",
    ],
  },
  {
    id: 7,
    title: "Digital Marketing Executive",
    location: "Nashik, India",
    type: "Full-time",
    slug: "digital-marketing-executive",
    experience: "2+ Years",
    categories: ["marketing", "SEO", "Social Media"],
    openings: 1,
    deadline: "October 15, 2025",
    department: "Marketing & Growth",
    salary: "₹4,00,000 – ₹6,00,000 per annum",
    description:
      "We are looking for a dynamic and results-driven Digital Marketing Executive to develop, implement, track, and optimize our digital marketing campaigns across all channels. You will play a crucial role in enhancing our brand awareness, driving web traffic, and acquiring leads/customers. If you are passionate about digital technologies and marketing trends, we'd love to meet you! 🚀",
    responsibilities: [
      "Plan and execute all digital marketing campaigns, including SEO/SEM, email, social media, and display advertising.",
      "Manage and maintain the organization's social media presence across all relevant digital channels.",
      "Measure and report on the performance of all digital marketing campaigns, assessing against goals (ROI and KPIs).",
      "Identify trends and insights to optimize ad spend and campaign performance.",
      "Collaborate with internal teams to create optimized landing pages and improve the user experience.",
      "Brainstorm new and creative growth strategies to increase our digital footprint.",
      "Conduct keyword research and use SEO best practices to increase site traffic.",
    ],
    qualifications: [
      "Bachelor's degree in Marketing, Communications, or a related field.",
      "2+ years of proven experience in a digital marketing or advertising position.",
      "Demonstrable experience managing SEO/SEM, email, social media, and/or display advertising campaigns.",
      "Solid knowledge of website analytics tools (e.g., Google Analytics, SEMrush, Ahrefs).",
      "Experience in setting up and optimizing Google Ads campaigns.",
      "Strong analytical skills and a data-driven approach to problem-solving.",
      "Excellent written and verbal communication skills.",
    ],
    niceToHave: [
      "Experience with content creation, including copywriting and basic graphic design.",
      "Familiarity with marketing automation tools like HubSpot or Mailchimp.",
      "Basic knowledge of HTML and CSS.",
      "Certifications in Google Ads or Google Analytics.",
      "Experience with A/B and multivariate experiments.",
    ],
    benefits: [
      "Competitive salary and performance incentives.",
      "Comprehensive health insurance plan.",
      "A supportive environment with opportunities for professional growth and training.",
      "A creative, collaborative, and fun work culture.",
      "Generous paid leave and flexible work arrangements.",
      "Regular team-building activities and company outings.",
    ],
  },
];

export default Carrers;
